var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/LZR/Notify/Important") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/LZR/Notify/Important",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0839,5.9999 C25.0279,5.9999 25.8769,6.5239 26.2999,7.3669 L39.9029,34.4749 C40.2909,35.2489 40.2519,36.1509 39.7969,36.8889 C39.3419,37.6259 38.5529,38.0659 37.6869,38.0659 L10.4819,38.0659 C9.6159,38.0659 8.8259,37.6259 8.3709,36.8889 C7.9169,36.1509 7.8769,35.2489 8.2659,34.4749 L21.8679,7.3669 C22.2909,6.5239 23.1399,5.9999 24.0839,5.9999 Z M24.0839,7.9999 C24.006025,7.9999 23.8286187,8.01980625 23.7050934,8.18489414 L23.6559,8.2649 L10.0529,35.3729 C9.9489,35.5799 10.0209,35.7539 10.0739,35.8389 C10.1259,35.9239 10.2489,36.0659 10.4819,36.0659 L37.6869,36.0659 C37.9199,36.0659 38.0419,35.9239 38.0949,35.8389 C38.1469,35.7539 38.2199,35.5799 38.1159,35.3729 L24.5129,8.2649 C24.3929,8.0259 24.1729,7.9999 24.0839,7.9999 Z M25.264,30.0664 L25.264,34.0664 L23.264,34.0664 L23.264,30.0664 L25.264,30.0664 Z M25.264,16.0664 L25.264,27.0664 L23.264,27.0664 L23.264,16.0664 L25.264,16.0664 Z",
    id: "Combined-Shape",
    fill: "#FFE500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.84b2f64a35ddd660fbf56bd51da5f0f3.svg";
export { ForwardRef as ReactComponent };